module.exports = __webpack_public_path__ + "img/Anciennes-Salines-Villeroy-Setes-900-600.481ab5f4.png";